export const SpecialistUserTypes = [
  'shareholders',
  'employee',
  'diplomat',
  'vip',
  'internal demo',
  'external demo',
  'field trials',
];
